import dayjs from 'dayjs';

import { FilterValues } from '@/shared/ui/GeneratikTable/GeneratikTableFilterPanel.types';

export const resetPastDateIfNoPermission = (
  filterValues: FilterValues,
  hasPermissionToCreatePastBookings: boolean,
): FilterValues => {
  if (hasPermissionToCreatePastBookings) {
    return filterValues;
  }

  const dateRange = filterValues.dateRange as { start?: string; end?: string } | undefined;
  if (!dateRange?.start && !dateRange?.end) {
    return filterValues;
  }

  const today = dayjs().startOf('day');
  const todayStr = dayjs().format('YYYY-MM-DD');
  const startDate = dateRange?.start ? dayjs(dateRange.start) : null;
  const endDate = dateRange?.end ? dayjs(dateRange.end) : null;

  const newStart = startDate && startDate.isBefore(today) ? todayStr : dateRange?.start;
  const newEnd = endDate && endDate.isBefore(today) ? todayStr : dateRange?.end;

  if (newStart === dateRange?.start && newEnd === dateRange?.end) {
    return filterValues;
  }

  return {
    ...filterValues,
    dateRange: { start: newStart, end: newEnd },
  };
};

export const adjustDatesIfNoPermission = (
  startDate: string | undefined,
  endDate: string | undefined,
  hasPermissionToCreatePastBookings: boolean,
): { start: string | undefined; end: string | undefined } => {
  if (hasPermissionToCreatePastBookings) {
    return { start: startDate, end: endDate };
  }

  if (!startDate && !endDate) {
    return { start: startDate, end: endDate };
  }

  const today = dayjs().startOf('day');
  const todayStr = dayjs().format('YYYY-MM-DD');
  const start = startDate ? dayjs(startDate) : null;
  const end = endDate ? dayjs(endDate) : null;

  const newStart = start && start.isBefore(today) ? todayStr : startDate;
  const newEnd = end && end.isBefore(today) ? todayStr : endDate;

  return { start: newStart, end: newEnd };
};

export const ensurePeriodFilterValue = (
  values: FilterValues,
  campaignStart: string | undefined,
  campaignEnd: string | undefined,
  hasPermissionToCreatePastBookings: boolean,
): FilterValues => {
  const dateRange = values.dateRange as { start?: string; end?: string } | undefined;
  if (dateRange?.start || dateRange?.end) return values;

  const { start, end } = adjustDatesIfNoPermission(
    campaignStart?.split('T')[0],
    campaignEnd?.split('T')[0],
    hasPermissionToCreatePastBookings,
  );
  if (!start && !end) return values;

  return { ...values, dateRange: { start, end } };
};

export const buildPeriodResetFilterValues = (
  campaignStart: string | undefined,
  campaignEnd: string | undefined,
  hasPermissionToCreatePastBookings: boolean,
  userType?: string,
): FilterValues => {
  const { start, end } = adjustDatesIfNoPermission(
    campaignStart?.split('T')[0],
    campaignEnd?.split('T')[0],
    hasPermissionToCreatePastBookings,
  );

  const values: FilterValues = {};
  if (start || end) {
    values.dateRange = { start, end };
  }
  if (userType === 'location') {
    values.published = 'true';
  }
  return values;
};
